import React from 'react';
import { Helmet } from 'react-helmet-async';

import { Box, BoxProps } from '@mui/material';

import { LoaderOverlay } from '~/components/Loader';
import { SITE_TITLE } from '~/env';
import * as LAYOUT from '~/pages/layout';

interface IPage extends Omit<BoxProps, 'ref'> {
  isLoading?: boolean;
  title?: string;
}

export const Page: React.FC<IPage> = (props) => {
  const { isLoading, title, children, sx, ...others } = props;
  return (
    <Box
      sx={[LAYOUT.CONTAINER, {
        height: '100vh',
        width: 'calc(100vw - 20px)',
        minWidth: 1430,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...others}
    >
      <Helmet>
        <title>{title || SITE_TITLE}</title>
      </Helmet>
      {isLoading && <LoaderOverlay sx={{ height: '90%' }} />}
      {!isLoading && children}
    </Box>
  );
};
